import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-user-info-modal',
    templateUrl: './user-info-modal.component.html',
    styleUrls: ['./user-info-modal.component.scss']
})
export class UserInfoModalComponent implements OnInit {

    constructor(private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public router: Router,
                public userService: UserService) { }

    ngOnInit(): void {}

    openSettings() {
        this.modalService.dismissAll();
        this.router.navigate(['/settings']);
    }

    getInitial() {
        
        if (
            this.userService.currentUser.keycloakUser.tokenParsed.family_name
            && this.userService.currentUser.keycloakUser.tokenParsed.given_name
        ) {
            return this.userService.currentUser.keycloakUser.tokenParsed.family_name.charAt(0)
            + this.userService.currentUser.keycloakUser.tokenParsed.given_name.charAt(0);
        }

        return this.userService.currentUser.keycloakUser.tokenParsed.email;
    }

}
